import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { IconButton, Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import { Link } from "react-router";
import { useVisualContext } from "../../context/VisualContext";

interface Props {
  title?: string;
  BackButton?: React.ReactNode;
  TitleComponent?: React.ReactNode;
  showDefaultBackButtonTo?: string;
  hideBorderLine?: boolean;
}

const GeneralPageHeader = ({
  title,
  BackButton,
  TitleComponent,
  showDefaultBackButtonTo,
  hideBorderLine,
  children,
}: PropsWithChildren<Props>) => {
  const { showSideMenu } = useVisualContext();
  const pl = showSideMenu ? 3 : 4;
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        pl: pl,
        pr: 3,
        pt: 0.5,
        width: "100%",
        borderBottom: hideBorderLine ? 0 : 1,
        borderColor: "divider",
      }}
    >
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        {BackButton}

        {showDefaultBackButtonTo && BackButton === undefined && (
          <IconButton component={Link} to={showDefaultBackButtonTo}>
            <ArrowBackRoundedIcon />
          </IconButton>
        )}

        {TitleComponent}

        <Typography id="page-header-title" sx={(theme) => ({ height: theme.spacing(6.5), pt: 2.2 })} variant="h6">
          {title}&nbsp;
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        {children}
      </Stack>
    </Stack>
  );
};

export default GeneralPageHeader;
